// eslint-disable-next-line eag/match-named-export
import {createContext, ReactNode, use} from 'react';
// eslint-disable-next-line no-restricted-imports
import {useSearchParams} from 'react-router-dom';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {noop} from 'shared/web';

import {FilterFormData} from '../types/FilterFormData';
import {parseFilterFormDataToSearchParams} from '../utils/parseFilterFormDataToSearchParams';
import {parseSearchParamsToFilterFormData} from '../utils/parseSearchParamsToFilterFormData';

type SelectedFiltersContextType = {
  selectedFilters: FilterFormData | null;
  onSelectFilters: (data: FilterFormData | null) => void;
};

const SelectedFiltersContext = createContext<SelectedFiltersContextType>({
  selectedFilters: null,
  onSelectFilters: noop,
});

type SelectedFiltersProviderProps = {
  children: ReactNode;
};

const SelectedFiltersProvider = (props: SelectedFiltersProviderProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onSelectFilters = (data: FilterFormData | null) => {
    const params = parseFilterFormDataToSearchParams(searchParams, data);
    setSearchParams(params, {replace: true});
  };

  const parsedFilters = parseSearchParamsToFilterFormData(searchParams);
  const hasAnyFilter = Object.values(parsedFilters).some((filter) => isNotNilOrEmpty(filter));

  const context: SelectedFiltersContextType = {
    selectedFilters: hasAnyFilter ? parsedFilters : null,
    onSelectFilters,
  };

  return (
    <SelectedFiltersContext.Provider value={context}>
      {props.children}
    </SelectedFiltersContext.Provider>
  );
};

const useSelectedFilters = () => use(SelectedFiltersContext);

export {SelectedFiltersProvider, useSelectedFilters};
